import { Moment } from "moment";
import * as moment from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel, SyncSingleDataModel } from "./syncModel";
import { MenuSettingViewModel, MenuSettingsDataModel2 } from "./menu.model";
import { Holiday, TimeSet, ArticleOptions, WebshopSettingsDataModel2, TimeSetDay, TimeSetDate } from "./webshop.model";
import { ItemTagStatusType, YourAPPProductType, ContentType, ImageOrientation, TranslationContentType } from "../contentTypes";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLanguageService } from "../../services/language.service";
import { environment } from "../../../../environments/environment";
import { IItemTagViewModel, IProductViewModel } from "./product.facade";
import { IItemGoup } from "./item_group.model";
import { BehaviorSubject, Observable } from "rxjs";
import { CoreLanguageManager } from "../../services/ILanguageManager";

export class ItemTagStorageViewModel {
  public id: number;
  public itemTagStatus: ItemTagStatusType;
}

export class ItemTagViewModel implements IItemTagViewModel {
  public id: number;
  public svgIcon: string;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    const _label = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.label_en) ? this.label_de : this.label_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_Bontext, this.id, _label);
    }
    else {
      return _label;
    }
  }
  public sortNumber: number;
  public color: string;
  public itemTagStatus: ItemTagStatusType;
}

export class ProductViewModel implements IProductViewModel {

  public get is_recipe_linking(): boolean {
    return false;
  }

  private _model: ProductDataModel4;

  public location: number;

  public get id(): number {
    return this._model.id;
  }
  public get artikelNo(): number {
    return this._model.artikel_nr;
  }
  public get free_item_nr(): number {
    return this._model.free_item_nr;
  }
  public get product_id(): number {
    return this._model.product_id;
  }
  public get usingtype(): number {
    return this._model.usingtype;
  }
  public isInGroup(item_group: IItemGoup): boolean {
    return this._model.inGroup(item_group.item_mappings);
  }
  public get label(): string {
    const _label = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.label_en) ? this._model.label_de : this._model.label_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_Bontext, this._model.id, _label);
    }
    else {
      return _label;
    }
  }
  public get hasExtras(): boolean {
    return this._model.hasExtras;
  }
  public get hasImage(): boolean {
    return this._model.last_image_update_at_hms > -1;
  }
  public get imageUrl(): string {
    if (this.hasImage)
      return ContentType.sub_Product + "/" + this._model.product_id + "_photo_" + ImageOrientation.Landscape + "/" + this._model.last_image_update_at_ymd + "/" + this._model.last_image_update_at_hms;
    else
      return ""
  }

  public itemTags: ItemTagViewModel[];// item tags aus unter products
  public amountOfLikedTags: number;
  /** Wenn false, so muss der schedule_hint angezeigt werden */
  public get availible(): boolean {
    return this.scheduler.active
  }; // nur false wenn alle unter products false sind
  /** Zeitsteuerungs Hinweis */
  public get schedule_hint(): string {
    return this.scheduler.hint
  };
  /** Zeitsteuerung */
  public scheduler: ScheduleView;

  public get model(): ProductDataModel4 {
    return this._model;
  }

  public constructor(location: number, model: ProductDataModel4, item_tags: ItemTagViewModel[], likeIds: number[], schedule_req: ScheduledForRequest) {
    this.location = location;
    this._model = model;
    this.amountOfLikedTags = 0;
    this.itemTags = [];
    if (model.tag_ids && model.tag_ids.length > 0 && item_tags) {
      this.itemTags.push(...item_tags.filter(itemTag => model.tag_ids.includes(itemTag.id)));
      if (this.itemTags && this.itemTags.length > 0) {
        this.itemTags.forEach(itemTag => likeIds.forEach((likedID) => likedID === itemTag.id ? this.amountOfLikedTags++ : "")
        )
      }
    }
    this.scheduler = model.isScheduledFor(schedule_req);
  }
}

export class ProductDetailViewModel {
  public id: number;
  public labelDE: string;
  public labelEN: string;
  public get label(): string {
    const _label = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.labelEN) ? this.labelDE : this.labelEN
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_Bontext, this.id, _label)
    }
    return _label
  }
  public description_de: string;
  public description_en: string;
  public get description(): string {
    const _description = InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.description_en) ? this.description_de : this.description_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_Details, this.id, _description)
    }
    return _description
  }
  public productId: number;
  public imagePhoto: string;
  public basePrice: number;
  public deposit: number;
  public price: number;
  public like: boolean;
  public rate: number;
  public lastSynceData: string;
  public nutritions: NutritionViewModel;
  public usingtype: UsingType;
  public productHeaderGroups: MenuSettingViewModel[];
  public productExtras: ProductExtraViewModel[];
  public itemTags: ItemTagViewModel[];
  public bonusAction_id?: number;
  public benefit_id?: number;
  public benefit_loss_id?: number;
  /** use e-Commerce */
  public use_eCommerce: boolean;
  /**Item content */
  public item_content_de: string;
  public item_content_en: string;
  public get item_content(): string {
    const regex = new RegExp(/([*])(?:(?=(\\?))\2.)*?\1/g, 'gi');
    /** ersetzt * im deutschen Text durch <b> für bold (fett) */
    this.item_content_de = this.item_content_de.toString().replace(regex, (match) => `<b>${match.replace(/\*/g, '')}</b>`);
    /** ersetzt * im englischen Text durch <strong> für bold (fett) */
    this.item_content_en = this.item_content_en.toString().replace(regex, (match) => `<b>${match.replace(/\*/g, '')}</b>`);
    const _itemcontent = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.item_content_en) ? this.item_content_de : this.item_content_en;
    if (YourAPPProductType.sot === environment.producttype) {
      CoreLanguageManager.translate(TranslationContentType.Article_ItemContent, this.id, _itemcontent)
    }
    return _itemcontent
  }
  /** has item content */
  public get hasItemContent(): boolean {
    return this.item_content.length > 0;
  }
  public item_provider_name_de: string;
  public item_provider_name_en: string;
  /** Item provider */
  public get item_provider_name(): string {
    const _item_provider_name = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.item_provider_name_en) ? this.item_provider_name_de : this.item_provider_name_en;
    if (YourAPPProductType.sot === environment.producttype) {
      CoreLanguageManager.translate(TranslationContentType.Article_ItemProviderName, this.id, _item_provider_name)
    }
    return _item_provider_name
  }

  public item_provider_addr_de: string;
  public item_provider_addr_en: string;
  /** Provider addr. */
  public get item_provider_addr(): string {
    const _item_provider_addr = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.item_provider_addr_en) ? this.item_provider_addr_de : this.item_provider_addr_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_ItemProviderAddr, this.id, _item_provider_addr)
    }
    return _item_provider_addr
  }

  /**has item provider name */
  public get hasItemProviderName(): boolean {
    const me = this;
    return this.item_provider_name.length > 0;
  }
  /**has item provider Addr. */
  public get hasItemProviderAddr(): boolean {
    const me = this;
    return this.item_provider_addr.length > 0;
  }
  /**Base unit */
  public item_base_unit: BaseUnit;
  /** Base factor  */
  public item_base_factor: number;
  /** Caffeine level */
  public item_caffeine: number;
  /** has caffeine level*/
  public get hasCaffeineLevel(): boolean {
    return this.item_caffeine > 0;
  }
  /** Alcohol level */
  public item_alcohol: number;
  /** has alcohol  level */
  public get hasAlcoholLevel(): boolean {
    return this.item_alcohol > 0;
  }
  /** Merkmal Vorverpackt */
  public prepackaged: boolean;
}

export class NutritionViewModel {
  public get header(): string {
    return InternationalisationService.locale === "de" ? this.headerDE : this.headerEN;
  }
  public headerDE: string;
  public headerEN: string;
  public get nutritionItemViewModels(): NutritionItemViewModel[] {
    return InternationalisationService.locale === "de" ? this.nutritionItemViewModelsDE : this.nutritionItemViewModelsEN;
  }
  public nutritionItemViewModelsDE: NutritionItemViewModel[];
  public nutritionItemViewModelsEN: NutritionItemViewModel[];
}

export class NutritionItemViewModel {
  public title: string;
  public value: string;
}

export class ProductExtraViewModel {
  public productExtraItems: ProductExtraItemViewModel[];
  public queryOrder: number;
  public forceMode: boolean;
  public maxChoices: number;
  public extratextID: number;
  public get title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.titleEN) ? this.titleDE : this.titleEN;
  }
  public titleDE: string;
  public titleEN: string;
}

export class ProductExtraItemViewModel {
  public id: number;
  public rez_id: number;
  public product_id: number;
  public subIndex: number;
  public queryGroup: number;
  public get title(): string {
    const _title = InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.titleEN) ? this.titleDE : this.titleEN;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.ArticleExtra_Artikel_Name, this.id, _title);
    }
    return _title;
  }
  public titleDE: string;
  public titleEN: string;
  public price: number;
  public deposit: number;
  public order: number;
  public isAvailable: boolean;
  /** Extra hat Kennzeichen, wird mit initAdditionalInfo gefüllt, sonst ist es false */
  public _hasAdditionalInfoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  /** hasAdditionalInfo wird asynchrone über initAdditionalInfo ermittelt und kann erst zu einem Späteren Zeitpunkt auf true sich ändern */
  public get hasAdditionalInfo$(): Observable<boolean> {
    return this._hasAdditionalInfoSubject.asObservable();
  };

  public _displayExtraBasePriceSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get displayExtraBasePrice$(): Observable<boolean> {
    return this._displayExtraBasePriceSubject.asObservable();
  };

  /** Füllt die AdditionalInfo vom Extra. Passiert auserhalb, da ee momentan im Model liegt, kann zu einem Service umgewandelt werden
   * @param productDetails muss nur mitgegeben werden, wenn AditionalInformation berechnet werden sollen
   * @param menuSetting muss nur mitgegeben werden, wenn AditionalInformation berechnet werden sollen
   */
  public initAdditionalInfo(productDetails: ProductDetailsDataModel3 | null, menuSetting: MenuSettingsDataModel2 | null): void {
    const me = this;
    let hasAdditionalInfo = false;
    let displayExtraBasePrice = false;
    if (productDetails && menuSetting) {
      me._productDetails = productDetails;
      me._menuSetting = menuSetting;
      // prüfung ob die AditionalInformation wirklich vorliegen
      hasAdditionalInfo = (menuSetting.use_allergens && !Utils.IsNullOrEmpty(productDetails.allergens_de)) ||
        (menuSetting.use_additives && !Utils.IsNullOrEmpty(productDetails.additives_de)) ||
        (menuSetting.use_nutrition_values && !Utils.IsNullOrEmpty(productDetails.nutrition_values_de)) ||
        (menuSetting.use_co2 && productDetails.co2 > 0) || // oder sollte co2 immer angezeigt werden?
        (menuSetting.use_eCommerce && (productDetails.item_base_unit_id != BaseUnit.NONE || productDetails.item_caffeine > 0 || productDetails.item_alcohol > 0 || !Utils.IsNullOrEmpty(productDetails.item_content) || !Utils.IsNullOrEmpty(productDetails.item_provider_name))) ||
        (productDetails.details_de.length > 0 || productDetails.details_en.length > 0);
    }

    if (menuSetting.use_eCommerce) {
      displayExtraBasePrice = menuSetting.use_eCommerce;
    }
    if (me._displayExtraBasePriceSubject.value !== displayExtraBasePrice) {
      me._displayExtraBasePriceSubject.next(displayExtraBasePrice)
    }

    if (me._hasAdditionalInfoSubject.value !== hasAdditionalInfo) {
      me._hasAdditionalInfoSubject.next(hasAdditionalInfo);
    }
  }
  private _productDetails: ProductDetailsDataModel3;
  /** Artikel Details Model vom Extra, wird nur mit initAdditionalInfo gefüllt und nur wenn es AditionalInformation angezeigt werden sollen */
  public get productDetails() {
    return this._productDetails;
  }
  private _menuSetting: MenuSettingsDataModel2;
  /** MenüSettings, wird nur mit initAdditionalInfo gefüllt und nur wenn es AditionalInformation angezeigt werden sollen */
  public get menuSetting() {
    return this._menuSetting;
  }
}

export class ProductPricesModel {
  public bestPE: number;
  public price: number;
  public priceWithExtras: number;
  public discountPrice: number; // discount applied to price limited by nodiscount and mindiscount
  public discountPriceWithExtras: number; // discount applied to price limited by nodiscount and mindiscount
  public deposit: number;
  public depositWithExtras;
  public vat: number;
  public extras: { [id: number]: ProductExtraPricesModel } = {};
}

export class ProductExtraPricesModel {
  public price: number;
  public discountPrice: number;
  public deposit: number;
}

// Enums
export enum UsingType {
  // only the known UsingTypes are defined here
  // everything else is considered a standart product
  Standart = 0,
  Webvoucher = 4, // Fix Webvoucher;
  VariableWebvoucher = -4, // Variable Webvoucher have a price of 0;
}

// Requests
export class ProductsSyncModel4 extends SyncModel {
  public hyp_cus_nr: number; // Location
  public sortiment: string; // A,B,C,D
}

export class ProductDetailsSyncModel extends SyncModel {
  /** Achtung ist product.id (not product_id) */
  public id: number;
}

export class AllProductDetailsSyncModel extends SyncModel {
  public hyp_cus_nr: number; // Location
  public sortiments: string[]; // multible from A,B,C,D
}

/** Daten Paket, welcher benötigt wird und die Zeitsteuerung */
export class ScheduledForRequest {
  /** Momentan zu prüfender Zeitpunkt */
  public now: Moment;
  /** Tag aus now als YMD (als Cache weil die funktion in einer schleife verwendet wird) */
  public now_ymd: number;
  /** Uhrzeit aus now als HMS (als Cache weil die funktion in einer schleife verwendet wird) */
  public now_hms: number;
  /** Feiertage zur bestimmung des TimeSetDates */
  public holidays: Holiday[];
  /** genutzte TimeSets der erweiterten Zeitsteuerung */
  public time_sets: TimeSet[];
  /** nutzung der erweiterten Zeitsteuerung */
  public article_option: ArticleOptions;
  /** wird für die übersetzung des Hinweistextes verwendet */
  public coreLanguageService: CoreLanguageService;

  public constructor(now: Moment, location: number, webshop_settings: WebshopSettingsDataModel2, coreLanguageService: CoreLanguageService, sotArticleOption?: ArticleOptions) {
    this.now = now;
    this.now_ymd = Utils.GetYMDFromMoment(now);
    this.now_hms = Utils.GetHMSFromMoment(now);
    this.article_option = (YourAPPProductType.sot === environment.producttype) ? sotArticleOption : webshop_settings.article_option;
    this.time_sets = webshop_settings.time_sets;
    if (webshop_settings.holidays)
      this.holidays = webshop_settings.holidays.filter((holiday) => holiday.location === location);
    this.coreLanguageService = coreLanguageService;
  }
}

/** Artikel darstellung bei Zeitsteuerung */
export class ScheduleView {
  /** Artikel ist verkaufsfähig (wenn true, ist hide und hint zu ignorieren) */
  public active: boolean = true;
  /** Wenn artikel nicht verkaufs fähig ist, sagt hide aus, ob es Ausgeblendet werden soll.
   * Wenn False, ist der Artikel disabled mit dem hint als Hinweis, warum er nicht verfügbar ist.
   */
  public hide: boolean = false;
  /** Hinweis text, welcher angezeigt wird wenn der Artikel nicht verkaufsfähig ist und nicht versteckt wird. */
  public hint: string = "";
}

// Responses
/** Product */
export class ProductDataModel4 extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  /* property for internal usage, results if details are up to date */
  public fresh_details: boolean;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
  public hgr_grp_id: number;
  public wgr_grp_id: number;
  public ugr_grp_id: number;
  public order: number;
  public artikel_nr: number;
  public free_item_nr: number;
  public ugr_sort: string;
  public product_id: number;
  public label_de: string;
  public label_en: string;// todo remove and use only core_language_manager
  /** hasExtras beschreibt ob das Produkt Extras zur Auswahl hat.
   * dazu zählen keine Extras, die teil einer automatisch hinzugefügten Auswahl sind (nur 1 Auswahl und erzwungen)
   */
  public hasExtras: boolean;

  public hasSubextras: boolean;

  /** Bruttopreis */
  public price: number; // 
  /**  Bruttopreis (Mit ersten Auswahlen der Zwangsabfragen in Zwangsanzahl) */
  public extras: number;
  /** Percent: eg 19 = 19% */
  public vat: number;
  /** Percent: eg 7 = 7% */
  public vat_ah: number;
  /** Pfand ohne Extras */
  public dep: number;
  /** Pfand Außerhaus ohne Extras */
  public dep_ah: number;
  /** Pfand (Mit ersten Auswahlen der Zwangsabfragen in Zwangsanzahl) */
  public dep_with_extras: number;
  /** Pfand Außerhaus (Mit ersten Auswahlen der Zwangsabfragen in Zwangsanzahl) */
  public dep_with_extras_ah: number;
  /** Kein Rabatt */
  public noDiscount: boolean;
  /** Minum Bruttopreis durch Discount */
  public minDiscountPrice: number;
  public prices: ProductPriceDataModel4[];

  public keywords_de: string;
  public keywords_en: string;// todo remove and use only core_language_manager
  public hgr_grp_id_item: number;
  public wgr_grp_id_item: number;
  public ugr_grp_id_item: number;
  public usingtype: number | UsingType;
  /** Verkaufsfähig */
  public saleable: boolean;
  /** Artikel TAG-IDs */
  public tag_ids: number[];
  /** Altersbegrenzung für Kauf */
  public ask_age: number;

  /** Is Product only available at a scheduled timeslot */
  public scheduled: boolean;
  /** If 0 => scheduled for every day */
  public scheduled_from_ymd: number;
  public scheduled_to_ymd: number;
  public scheduled_from_hms: number;
  public scheduled_to_hms: number;
  /** id der erweiterten Zeitsteuerungs Gruppe, 0 == keine Gruppe */
  public time_set: number;

  /** Prüfung ob die Uhrzeit sich im Zeitraum befindet.
   * Achtung: wenn from größer to ist, so wird die Zeitspanne als ausschliesend betrachtet.
   * z.B. 16:00-8:00 wird als 0:00-8:00 und 16:00-23:59 geprüft
   */
  private isInTime(hms: number, from_hms: number, to_hms: number) {
    let in_time: boolean = true;
    if (to_hms > from_hms) {
      // zeit ist einschliessend
      if (hms > to_hms || hms < from_hms) {
        in_time = false;
      }
    } else if (from_hms > to_hms) {
      // zeit ist ausschließend
      if (hms > to_hms && hms < from_hms) {
        in_time = false;
      }
    }
    return in_time;
  }

  /** Aus dem Zeitpunkt "now" (ymd und hms) wird der für den Tag zuständige TimeSetDate ermittelt */
  private getTimeSetDate(now: Moment, now_ymd: number, now_hms: number, time_sets: TimeSet[], holidays: Holiday[]): TimeSetDate {
    const time_set = time_sets.find((set) => set.id === this.time_set);
    if (time_set) {
      // Feiertag wird zuerst geprüft
      if (holidays) {
        const find_holiday = (day_ymd: number, day_hms: number): ((day: Holiday) => boolean) => {
          return (day: Holiday): boolean => {
            // ist Feiertag im Zeitraum
            return (day_ymd > day.begin_date_ymd && day_ymd < day.end_date_ymd)
              || // oder ist am ersten Tag und in der Zeitspanne
              (day_ymd == day.begin_date_ymd && day_hms > day.begin_time_hms && (day_hms < day.end_time_hms || day_ymd < day.end_date_ymd))
              || // oder ist am letzten Tag und in der Zeitspanne
              (now_ymd == day.end_date_ymd && day_hms < day.end_time_hms && (day_hms > day.begin_time_hms || day_ymd > day.begin_date_ymd));
          }
        }
        const holiday = holidays.find(find_holiday(now_ymd, now_hms));
        if (holiday) {
          const day = time_set.days.find(day => day.day === TimeSetDay.Holiday);
          return day;
        } // else heute kein Feiertag, weiter prüfen auf "Tag vor dem Feiertag"

        const next_day_ymd = Utils.GetYMDFromMoment(Utils.GetMomentFromInt(now_ymd).add(1, "day"))
        const next_day_holiday = holidays.find(find_holiday(next_day_ymd, now_hms));
        if (next_day_holiday) {
          const day = time_set.days.find(day => day.day === TimeSetDay.BeforeHoliday);
          if (day && day.active) {
            return day;
          } // else Vorfeiertag ist nicht activ, behandeln wie Wochentag
        } // else kein Vorfeiertag, behandeln wie Wochentag
      } else {
        console.error("holidays not found");
      }

      // Wochentag bestimmung Mo=1 bis So=7, darum isoWeekday aus Moment
      const weekday = now.isoWeekday();
      const weekday_time_set = time_set.days.find(day => day.day === weekday);
      if (weekday_time_set.active && weekday_time_set.from_time_hms < weekday_time_set.to_time_hms && now_hms > weekday_time_set.from_time_hms && now_hms < weekday_time_set.to_time_hms) {
        return weekday_time_set;
      } // else Wochentag hat keine aktive erweiterte Zeitsteuerung
      // prüfen den vortag
      const prev_weekday = weekday == 1 ? 7 : weekday - 1;
      const prev_weekday_time_set = time_set.days.find(day => day.day === prev_weekday);
      if (prev_weekday_time_set.active && prev_weekday_time_set.from_time_hms > prev_weekday_time_set.to_time_hms && now_hms < prev_weekday_time_set.to_time_hms) {
        return prev_weekday_time_set;
      } else {
        return weekday_time_set;
      }
    }
    return null; // no time set found
  }

  /**
   * Prüfung der 
   * unter der berücksichtigung der erweiterten Zeitsteuerung.
   * @param now Momentan zu prüfender Zeitpunkt
   * @param now_ymd Tag aus now als YMD (als Cache weil die funktion in einer schleife verwendet wird)
   * @param now_hms Uhrzeit aus now als HMS (als Cache weil die funktion in einer schleife verwendet wird)
   * @param holidays Feiertage zur bestimmung des TimeSetDates
   * @param time_sets genutzte TimeSets der erweiterten Zeitsteuerung
   * @param article_option nutzung der erweiterten Zeitsteuerung
   * @param coreLanguageService wird für die übersetzung des Hinweistextes verwendet
   * @returns boolean is articled available by schedule
   */
  public isScheduledFor(request: ScheduledForRequest): ScheduleView {
    const me = this;
    const result = new ScheduleView();

    if (me.scheduled) {
      // Tag prüfen
      let isScheduledForDay: boolean = true;
      if (me.scheduled_from_ymd !== 0 && request.now_ymd < me.scheduled_from_ymd) {
        isScheduledForDay = false; // zu früh
      } else if (me.scheduled_to_ymd !== 0 && request.now_ymd > me.scheduled_to_ymd) {
        isScheduledForDay = false; // zu spät
      }
      if (isScheduledForDay) {
        // erweiterte Zeitsteuerung wird vor der einfachen Zeit geprüft
        if (me.time_set > 0 && request.time_sets) {
          const date_time_set = me.getTimeSetDate(request.now, request.now_ymd, request.now_hms, request.time_sets, request.holidays);
          if (date_time_set) {
            result.active = date_time_set.active && this.isInTime(request.now_hms, date_time_set.from_time_hms, date_time_set.to_time_hms);
            if (!result.active) {
              result.hide = request.article_option === ArticleOptions.hide; // else showHint
              if (!result.hide) {
                result.hint = (InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(date_time_set.resp_txt_en) ? date_time_set.resp_txt : date_time_set.resp_txt_en);
              }
            }
            if (Utils.IsNullOrEmpty(result.hint)) {
              if (environment.producttype == YourAPPProductType.sot) {
                result.hint = request.coreLanguageService.value("details_not_available");
              } else {
                result.hint = request.coreLanguageService.value("phArticleCard_ArticleUnavailable");
              }
            }
            return result; // wenn erw. Zeitsteuerung aktiv ist die Einfache nicht relevant
          } else {
            console.error("date_time_set from " + me.time_set + " and " + request.now_ymd + " " + request.now_hms + " of product " + me.id + " not found");
          }
        }

        // einfache Zeit prüfen
        let isScheduledForTime: boolean = this.isInTime(request.now_hms, me.scheduled_from_hms, me.scheduled_to_hms);
        // erster Tag hat seine erste Uhrzeit
        if (me.scheduled_from_ymd === request.now_ymd && request.now_hms < me.scheduled_from_hms) {
          isScheduledForTime = false; // zu früh am ersten Tag
        }
        if (!isScheduledForTime) {
          result.active = false;
          // todo ist bei einfacher Zeitsteuerung, der Defaulttext doch anzuwenden, statt es zu verstecken?
          // b einfache zeitsteuerung wie erweiterte zeitsteuerung behandeln
          result.hide = !(request.article_option === ArticleOptions.showHint);
          if (!result.hide) {
            if (environment.producttype == YourAPPProductType.sot) {
              result.hint = request.coreLanguageService.value("details_not_available");
            } else {
              result.hint = request.coreLanguageService.value("phArticleCard_ArticleUnavailable");
            }
          } // else ist hidden, kein text notwendig
        }
      } else {
        result.active = false;
        // erweiterte Zeitsteuerung prüfen, notwendig für den Hinweis
        result.hide = !(me.time_set > 0 && request.article_option === ArticleOptions.showHint);
        if (!result.hide) {
          const date_time_set = me.getTimeSetDate(request.now, request.now_ymd, request.now_hms, request.time_sets, request.holidays);
          if (date_time_set) {
            result.hint = (InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(date_time_set.resp_txt_en) ? date_time_set.resp_txt : date_time_set.resp_txt_en);
          } else {
            console.error("date_time_set from " + me.time_set + " and " + request.now_ymd + " " + request.now_hms + " of product " + me.id + " not found");
          }
          if (Utils.IsNullOrEmpty(result.hint)) {
            if (environment.producttype == YourAPPProductType.sot) {
              result.hint = request.coreLanguageService.value("details_not_available");
            } else {
              result.hint = request.coreLanguageService.value("phArticleCard_ArticleUnavailable");
            }
          }
        } // else ist hidden, kein text notwendig
      }
    } // else not scheduled
    return result;
  }

  /** checks, is product in the group (includes hg, wg and ug) */
  public inGroup(group_ids: ReadonlyArray<number>): boolean {
    // 1. wg, 2. ug und 3. hg, da es die meist genutzte reihenfolge ist
    return group_ids.includes(this.wgr_grp_id_item) || group_ids.includes(this.ugr_grp_id_item) || group_ids.includes(this.hgr_grp_id_item);
  }

  public DeserializeSubTypes(): void {
    const me = this;
    // not convertet for performance, because ProductPriceDataModel2 is simple type
    //if (Array.isArray(me.prices)) {
    //  const prices = me.prices;
    //  for (let i = 0; i < prices.length; ++i) {
    //    const price = prices[i];
    //    if (Object.getPrototypeOf(price) !== ProductPriceDataModel2) {
    //      prices[i] = Utils.GetExtend(new ProductPriceDataModel2(), price);
    //    }
    //  }
    //}
  }
}

/** ProductPrice */
export class ProductPriceDataModel4 {
  public pe: number;
  public price: number; // Bruttopreis
  /** price with extras */
  public extras: number; // Bruttopreis Mit ersten Auswahlen der Zwangsabfragen in Zwangsanzahl
  public vat: number; // Percent: eg 19 = 19%
  public vat_ah: number; // Percent: eg 7 = 7%
  /** Pfand ohne Extras */
  public dep: number;
  /** Pfand Außerhaus ohne Extras */
  public dep_ah: number;
  /** Pfand mit Extras */
  public dep_with_extras: number;
  /** Pfand Außerhaus mit Extras */
  public dep_with_extras_ah: number;
}

export class ProductsSyncDataModel4 extends SyncDataModel {
  public products: ProductDataModel4[];
  /** ProductIDs welche sich nicht in dem abgefragtem Sortiment befinden
   * da bei einem entfernen aus dem Sortiment, dieser weder gelöscht oder
   * noch als nicht verkaufsfähig wird, da er im anderen Sortiment enthalten sein kann */
  public productsNotInSortiment: number[];
  public get models(): DataModel[] { return this.products; }
  public DeserializeType(): void {
    this._DeserializeType(ProductDataModel4);
  }
}

/** ProductExtra */
export class ProductExtraDataModel3 {
  public id: number;
  public rez_id: number;
  public product_id: number;
  public sort_nr: number;
  public title_de: string;
  public title_en: string;// todo remove and use only core_language_manager
  public price: number;
  public SubIndex: number;
  public NoSortA: boolean;
  public NoSortB: boolean;
  public NoSortC: boolean;
  public NoSortD: boolean;
  //price_ah = (price*(1+vat_at/100))/(1+vat/100) : vat from Product
  /** deposit */
  public dep: number;
  /** deposit */
  public dep_ah: number;
  public q: number; // q1 = (q >> 0) & 1
  /**
   * Returns wheter the extra is part of extragroup i
   * ! This is invalid for SubExtras, those share the group of the parent extra
   * @param i extraGroup ID 1-16
   */
  public getQ(i: number): boolean {
    return ((this.q >> i - 1) & 1) == 1;
  }
  public prices: ProductExtraPriceDataModel3[];
}

/** ProductExtraPrice */
export class ProductExtraPriceDataModel3 {
  public pe: number;
  public price: number;
  /** deposit */
  public dep: number;
  /** deposit */
  public dep_ah: number;
}

/** ProductExtratext */
export class ProductExtratextDataModel3 {
  public q1: string;
  public q2: string;
  public q3: string;
  public q4: string;
  public q5: string;
  public q6: string;
  public q7: string;
  public q8: string;
  public q9: string;
  public q10: string;
  public q11: string;
  public q12: string;
  public q13: string;
  public q14: string;
  public q15: string;
  public q16: string;
}

/** ProductExtraMode */
export class ProductExtraModeDataModel3 {
  /** q=question froce mode */
  public q: number; // q1 = (q >> 0) & 1
  public getForceMode(i: number): boolean {
    return ((this.q >> i - 1) & 1) == 1;
  }
  public c1: number; // count: 0 = 1
  public c2: number;
  public c3: number;
  public c4: number;
  public c5: number;
  public c6: number;
  public c7: number;
  public c8: number;
  public c9: number;
  public c10: number;
  public c11: number;
  public c12: number;
  public c13: number;
  public c14: number;
  public c15: number;
  public c16: number;
}

/** Basiseinheit */
export enum BaseUnit {
  /** Hat keine Basiseinheit */
  NONE = 0,
  /** Stück */
  PIECE = 1,
  /** Liter */
  LITER = 2,
  /** Kilo */
  KILO = 3
}

/** ProductDetails */
export class ProductDetailsDataModel3 extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  // ProductDetailsDataModel.id = ProductDataModel.id
  public id: number;
  public extras: ProductExtraDataModel3[];
  public extratext_id: number;
  public extratext_de: ProductExtratextDataModel3;
  public extratext_en: ProductExtratextDataModel3;
  public extramode: ProductExtraModeDataModel3;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;

  public baseprice: number; // Bruttopreis

  public co2: number;
  public nutrition_title_de: string;
  public nutrition_title_en: string;
  public nutrition_values_de: string;
  public nutrition_values_en: string;
  public allergens_de: string;
  public allergens_en: string;
  public additives_de: string;
  public additives_en: string;
  public details_de: string;
  public details_en: string;// todo remove and use only core_language_manager
  /** default menügang */
  public menu_course: number;
  /** inhaltsbeschreibung */
  public item_content: string;
  public item_content_en: string;// todo remove and use only core_language_manager
  /** inverkehrsbringer */
  public item_provider_name: string;
  public item_provider_name_en: string;// todo remove and use only core_language_manager
  /** adresse vom inverkehrsbringer */
  public item_provider_addr: string;
  public item_provider_addr_en: string;// todo remove and use only core_language_manager
  /** basis einheit */ //! TODO item_base_unit_id wieder in item_base_unit umbennen, sobald alle YourAPP APPs aktualisiert wurden
  public item_base_unit_id: BaseUnit;
  /** basis einheitsfactor */
  public item_base_factor: number;
  /** coffein menge */
  public item_caffeine: number;
  /** aclohol menge */
  public item_alcohol: number;
  /** Merkmal Vorverpackt */
  public prepackaged: boolean;

  public DeserializeSubTypes(): void {
    const me = this;
    if (Array.isArray(me.extras)) {
      const extras = me.extras;
      for (let i = 0; i < extras.length; ++i) {
        const extra = extras[i];
        if (Object.getPrototypeOf(extra) !== ProductExtraDataModel3) {
          extras[i] = Utils.GetExtend(new ProductExtraDataModel3(), extra);
          // todo fals nötig kann hier (prices: ProductExtraPriceDataModel3) deserializiert werden
        }
      }
    }
    if (!Utils.IsNull(me.extratext_de)) {
      if (Object.getPrototypeOf(me.extratext_de) !== ProductExtratextDataModel3) {
        me.extratext_de = Utils.GetExtend(new ProductExtratextDataModel3(), me.extratext_de);
      }
    }
    if (!Utils.IsNull(me.extratext_en)) {
      if (Object.getPrototypeOf(me.extratext_en) !== ProductExtratextDataModel3) {
        me.extratext_en = Utils.GetExtend(new ProductExtratextDataModel3(), me.extratext_en);
      }
    }
    if (!Utils.IsNull(me.extramode)) {
      if (Object.getPrototypeOf(me.extramode) !== ProductExtraModeDataModel3) {
        me.extramode = Utils.GetExtend(new ProductExtraModeDataModel3(), me.extramode);
      }
    }
  }
}

export class ProductDetailsSyncSingleDataModel3 extends SyncSingleDataModel<ProductDetailsDataModel3> {
  public product_details: ProductDetailsDataModel3;
  public get model(): ProductDetailsDataModel3 { return this.product_details; }
  protected setModel(model: ProductDetailsDataModel3) {
    this.product_details = model;
  }
  public DeserializeType(): void {
    this._DeserializeType(ProductDetailsDataModel3);
  }
}

export class AllProductDetailsSyncDataModel3 extends SyncDataModel {
  public product_details: ProductDetailsDataModel3[];
  public get models(): DataModel[] { return this.product_details; }
  public DeserializeType(): void {
    this._DeserializeType(ProductDetailsDataModel3);
  }
  /** hilfs funktion umm es auf die einzelnen objecte zu zerlegen */
  public get product_details_as_single(): ProductDetailsSyncSingleDataModel3[] {
    const me = this;
    const base = {
      request_at_ymd: me.request_at_ymd,
      request_at_hms: me.request_at_hms,
      product_details: null,
    };
    return me.product_details.map<ProductDetailsSyncSingleDataModel3>((product_details) => {
      return Utils.GetExtend(new ProductDetailsSyncSingleDataModel3(), { ...base, product_details: product_details });
    });
  }
}

export class ArticleAvailabilitySyncModel extends SyncModel {
}

export class ArticleAvailabilityDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public location: number; // === location === hyp_cus_nr
  public product_ids: string; // mit | getrennt
  public product_ids_count: string; // mit | getrennt
  public product_ids_blacklist: string; // mit | getrennt
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class ArticleAvailabilitySyncDataModel extends SyncDataModel {
  public article_availability: ArticleAvailabilityDataModel[];
  public get models(): DataModel[] { return this.article_availability; }
  public DeserializeType(): void {
    this._DeserializeType(ArticleAvailabilityDataModel);
  }
}

export class ArticleTagSyncModel extends SyncModel {
}

export class ArticleTagDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public active: boolean;
  public deleted: boolean;
  public sort_no: number;
  public group: string;
  public name_de: string;
  public name_en: string; // todo remove and use only core_language_manager
  public svg: string;
  public color: string;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class ArticleTagSyncDataModel extends SyncDataModel {
  public article_tags: ArticleTagDataModel[];
  public get models(): DataModel[] { return this.article_tags; }
  public DeserializeType(): void {
    this._DeserializeType(ArticleTagDataModel);
  }
}